export function strRemove(str, startIndex, count) {
    return str.substr(0, startIndex) + str.substr(startIndex + count);
}

export function nSpliceReplaceStr(str, splices) {
    var returnStr = '',
        replaced = [];

    for(var i = 0; i < str.length; i++) {
        var char = str.charAt(i),
            found = false;

        for(var j = 0; j < splices.length; j++) {
            var splice = splices[j];
            var to = splice.from + splice.count - 1;

            if(i >= splice.from && i <= to) {
                found = true;

                if(replaced.indexOf(j) < 0) {
                    returnStr += splice.replace;
                    replaced.push(j)
                }
            }
        }

        if(!found) {
            returnStr += char;
        }
    }

    return returnStr;
}

export function indicesOf(searchStr, str, from = 0, to = null, caseSensitive = true) {
    var startIndex = from,
        searchStrLen = searchStr.length,
        index, indices = [];

    to = !to ? str.length : to;

    if (!caseSensitive) {
        str = str.toLowerCase();
        searchStr = searchStr.toLowerCase();
    }

    while ((index = str.indexOf(searchStr, startIndex)) > -1 && index < to) {
        indices.push({
            from: index,
            to: index + searchStrLen
        });

        startIndex = index + searchStrLen;
    }

    return indices;
}

export function isEnclosed(str, pos, openStr, closeStr) {
    closeStr = typeof closeStr === 'undefined' ? openStr : closeStr;

    var openCount = indicesOf(openStr, str, 0, pos);
    var closeCount = indicesOf(closeStr, str, 0, pos);
    return openCount > closeCount;
}

export function slugify(text)
{
    return text.toString().toLowerCase()
        .replace(/\s+/g, '-')           // Replace spaces with -
        .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
        .replace(/\-\-+/g, '-')         // Replace multiple - with single -
        .replace(/^-+/, '')             // Trim - from start of text
        .replace(/-+$/, '');            // Trim - from end of text
}

export function trimHard(str, trimChars = ['\n', '\t', ' ', '   ']) {
    const isTrimmed = (c) => { return trimChars.indexOf(c) > -1; };

    let sFound  = false,
        sCleanedStr = '';

    for(let char of str) {
        if(!isTrimmed(char)) { sFound = true; }
        if(!isTrimmed(char) || sFound) {
            sCleanedStr += char;
        }
    }

    let eFound  = false,
        cleanedStr = '';

    for(let i = sCleanedStr.length-1; i >= 0; i--) {
        let char = sCleanedStr[i];

        if(!isTrimmed(char)) { eFound = true; }
        if(!isTrimmed(char) || eFound) {
            cleanedStr = char + cleanedStr;
        }
    }

    return cleanedStr;
}

export function parseQsArg(str, arg) {
    arg+='=';

    var causeFrom = str.indexOf(arg) + arg.length;

    if(causeFrom < -1) { return null; }

    var causeTo = str.indexOf('&', causeFrom);
    causeTo = causeTo > -1 ? causeTo : str.length;

    return str.substring(causeFrom, causeTo);
}